export enum RolUsuario {
  /** Tiene todos los permisos a excepción de modificar el usuario Master o hacer pedidos */
  Admin = 0,
  /** Puede ejecutar compras, descargar tarifas y ver condiciones */
  Asociado = 1,
  /** Puede ejecutar compras y descargar tarifas pero no ver las condiciones */
  Compras = 2,
  /** Puede simular compras y descargar tarifas. No puede ver condiciones */
  DemoAsociado = 3,
  /** Solamente puede ver su ficha de proveedor y articulos. Puede descargar tarifas */
  Proveedor = 4,
  /** Puede ejecutar compras. No puede descargar tarifas ni ver condiciones */
  Cliente = 5,
  /** Mismos permisos que Admin pero sin poder acceder a Administración */
  Ventas = 6, 
  /** Puede simular compras. No puede descargar tarifas ni ver condiciones */
  DemoCliente = 7,
  /** Tiene todos los permisos a excepción de ejecutar compras. Rol interno de 404 */
  Master = 99,
}
